export default __webpack_public_path__ + "static/media/FiguradoClosed.4e1cfb24.jpg";